<template>
  <div>  
    <div class="content-wrap">
      <header-component />
      <router-view />
      <pwa-install
        install-description="For a better experience, we highly encourage you to install the Enduro Biking app. Please follow the instructions below."
        manifest-url="/pwa/manifest.json"
      ></pwa-install>
    </div>

    <footer-component />
  </div>
</template>

<script>

import HeaderComponent from "./components/Header";
import FooterComponent from "./components/Footer";
import { onLogin, onLogout } from './vue-apollo';
import tooltip from '@/directives/tooltip.js'
import PWAInstall from '@khmyznikov/pwa-install';

export default {
  name: 'App',
  components: { HeaderComponent, FooterComponent, PWAInstall },
  async created() {
    if (process.env.VUE_APP_FRONT_URL.includes('https') && window.location.protocol !== 'https:') window.location.href = process.env.VUE_APP_FRONT_URL
    await this.getUser();
  },
  mounted() {

  },
  methods: {
    async getUser() {
      const result = await this.$http.get(process.env.VUE_APP_API_BASE_URL + "/guard");
      if (result && result.body && result.body.user) {
        await onLogin.apply(this, [this.$apollo.provider.defaultClient, result.body.user])
      } else {
        await onLogout.apply(this, [this.$apollo.provider.defaultClient])
      }
    },
  }
};
</script>

<style src="./styles/theme.scss" lang="scss" />